<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.check_password.fields.password.label')"
                    :placeholder="$t('forms.check_password.fields.password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :error="passwordError"
                    type="password"
                    valuePath="password"
                    @change="checkPassword($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('forms.check_password.buttons.cancel')"
                    :isSubmittable="false"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'cancel' })"
                ></common-button>
                <common-button :label="$t('forms.check_password.buttons.ok')" size="large" type="primary"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import AuthAPI from 'api/AuthAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin],

        data() {
            return {
                passwordError: '',
            }
        },

        methods: {
            handleFormSubmission(data) {
                const password = data.password
                this.handleRequest(AuthAPI.logIn(this.$auth.getUser().email, password))
                    .then(() => {
                        this.emitEvent({ name: 'edit-patient-enable' })
                    })
                    .catch(() => {
                        return (this.passwordError = this.$t('forms.check_password.wrong_password'))
                    })
            },

            checkPassword(event) {
                this.passwordError = ''
                this.change(event)
            },
        },
    }
</script>
